import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import DisplayPanel from 'common/DisplayPanel';
import EditDisplayPanel from 'edit/EditDisplayPanel';
import EditMapContainer from 'mapping/EditMapContainer';
import MapControls from 'mapping/MapControls';
import OverlaySelectContainer from 'mapping/OverlaySelectContainer';
import ConfirmModal from 'common/modals/ConfirmModal';
import QuitFlowModalContainer from 'common/modals/QuitFlowModalContainer';

const baseString = 'vra-script-creator-body';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-ui__screen__body': true
});
const ScriptCreatorBody = ({
  canChooseSeedProduct,
  scriptConfigView,
  selectedZoneIds,
  shouldScrollToSelectedZone,
  showLiquidApplication
}) => {
  return (
    <section className={classString}>
      <DisplayPanel
        isExtendedWidth={showLiquidApplication}
        isMaxWidth={canChooseSeedProduct}>
        <EditDisplayPanel
          scriptConfigView={scriptConfigView}
          selectedZoneIds={selectedZoneIds}
          shouldScrollToSelectedZone={shouldScrollToSelectedZone}
        />
      </DisplayPanel>
      <EditMapContainer />
      <ConfirmModal />
      <QuitFlowModalContainer />
      <MapControls>
        <OverlaySelectContainer/>
      </MapControls>
    </section>
  );
};
ScriptCreatorBody.propTypes = {
  canChooseSeedProduct: propTypes.bool.isRequired,
  scriptConfigView: propTypes.string.isRequired,
  selectedZoneIds: propTypes.array.isRequired,
  shouldScrollToSelectedZone: propTypes.bool.isRequired,
  showLiquidApplication: propTypes.bool.isRequired
};
export default ScriptCreatorBody;
